/**
 * Primary UI stack: Inter via `@fontsource/inter` (bundled; see `main.tsx`).
 * System fonts follow so UI stays readable before/without the webfont.
 */
export const APP_FONT_STACK = '"Inter", system-ui, -apple-system, "Segoe UI", sans-serif' as const
